<template>
  <container style='margin-top: 12px;height: 512px;' class='map-container' title='国有资产出租大数据分析'>
    <div class='address'>
      <img src="/img/bigdata/address.png" alt="">
      {{areaName}}
    </div>
    <div class="lenged">
        <div class="item">
          <img src="/img/bigdata/a.png" alt="">合同正常
        </div>
        <div class="item">
          <img src="/img/bigdata/b.png" alt="">合同到期
        </div>
        <div class="item">
          <img src="/img/bigdata/c.png" alt="">合同欠租
        </div>
    </div>
    <div id='areaMap' style='height: 480px;'>

    </div>
  </container>
</template>

<script>
  import container from "../container";
  import axios from 'axios'
  import {mapState} from 'vuex'
  import cityMap from '../../../../../assets/js/china-main-city-map'
  import {contractMap} from "../../../../../api/bigData";

  export default {
    name: "areaMap",
    components: {
      container,
    },
    data() {
      return {
        myChart: null,
        detail: {
          contractCount: 0,
          contractMaturity: 0,
          contractNormal: 0,
          contractRentArrears: 0,
        },
      }
    },
    methods: {
      initEcharts() {
        let that=this
        var echarts = require('echarts');
        //地图容器
        var chart = echarts.init(document.getElementById('areaMap'));
//34个省、市、自治区的名字拼音映射数组
        let cityName = this.cityName.split('市')[0]
        let code = cityMap[cityName] || '100000'
        if (!code) {
          return false
        }
//直辖市和特别行政区-只有二级地图，没有三级地图
        var special = ["北京", "天津", "上海", "重庆", "香港", "澳门"];
        var mapdata = [];
//绘制全国地图
        axios.get('/city/' + code + '.json').then(res => {
          // axios.get('/city/100000.json').then(res=>{
          let data = res.data
          var d = [];
          let cp=[]
          for (var i = 0; i < data.features.length; i++) {
            if (data.features[i].properties.name == this.areaName) {
              cp.push(data.features[i].properties.cp)

              d.push({
                name: data.features[i].properties.name,
                value: 11,
                visualMap: true,
                itemStyle: {
                  normal: {
                    areaColor: '#006ABA',
                  },
                },

              })
            } else {
              d.push({
                name: data.features[i].properties.name,
                visualMap: false,
              })
            }
          }
          mapdata = d;
          //注册地图
          echarts.registerMap(cityName, data);
          //绘制地图
          renderMap(cityName, d,cp);
        })

//地图点击事件
        chart.on('click', function (params) {
          that.$router.push({path: '/3dmap' })
        });

//初始化绘制全国地图配置
        var option = {
          tooltip: {
           show:false

          },
          geo: {},
          animationDuration: 1000,
          animationEasing: 'cubicOut',
          animationDurationUpdate: 1000

        };

        function renderMap(map, data,cp) {
            option.geo= {
              map: map,
              aspectScale: 0.75, //长宽比
              zoom: 1.1,
              roam: false,
              label:{
                color:'rgba(0,0,0,0)',
              },
              itemStyle: {
                normal: {
                  areaColor: '#274d68',
                  shadowColor: 'rgb(58,115,192)',
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  color:'rgba(0,0,0,0)',
                },
                emphasis: {
                  areaColor: '#274d68',
                  borderWidth: 0,
                  color: 'green',
                  label: {
                    show: false
                  }
                }
              }
            }
            option.series = [
              {
                name: map,
                type: 'map',
                mapType: map,
                roam: false,
                label: {
                  show: false,
                  normal: {
                    show: false,
                    textStyle: {
                      color: '#999',
                      fontSize: 13
                    },

                  },
                  emphasis: {
                    show: false,
                    textStyle: {
                      color: '#fff',
                      fontSize: 13
                    }
                  }
                },
                itemStyle: {
                  normal: {
                    areaColor: '#02246A',
                    borderColor: '#FEAE49',
                    borderWidth: 1,
                  },
                  emphasis: {
                    show: false,
                    areaColor: '#006ABA'
                  },
                },
                emphasis:{
                  show:false
                },
                data: data
              },
              {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                showEffectOn: 'render',
                zlevel:1,
                rippleEffect: {
                  period: 15,
                  scale: 4,
                  brushType: 'fill'
                },
                hoverAnimation: true,
                label: {
                  normal: {
                    show: true,
                    emphasis:{
                      show:false
                    },
                    formatter: function(params){
                      let str=that.areaName+' \n{img1|}  '+'合同正常：'+that.detail.contractNormal+' \n{img2|}  '+'合同到期：'+that.detail.contractMaturity+' \n{img3|}  '+'合同欠租：'+that.detail.contractRentArrears

                      return str
                    },
                    position: 'top',
                    backgroundColor: 'rgba(34,63,135,0.8)',
                    padding: [0, 10],
                    borderRadius: 3,
                    lineHeight: 32,
                    color: '#DCEBFF',
                    rich:{
                      verticalAlign: ' middle',
                      fline:{
                        padding: [0, 10, 10, 10],
                        color:'#ffffff'
                      },
                      tline:{
                        padding: [10, 10, 0, 10],
                        color:'#ffffff'
                      },
                      img1 : {
                        backgroundColor : {
                          image : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAAEhyb7BAAAAAXNSR0IArs4c6QAAAitJREFUOBGFVDtvFDEQ9sx5F0iQTpQRiniEIj8iSkuBgkQR0UYUpIwoQPwERIMoQQIhUSEKioiCNrr/AEUuF4SiK1Ek8rj1nof5vGvjPU7gYmfmm89jz8NrjK5iWD2AtFCI5U0xqiwAo8rDoOBz6YdcpXI0ERiWuHfXe78Ew9gD9xie8nDy9cL3eoPBZfYhrBGzmpgXD9y6Mu+HXQjvjX8FQ/U+Q4mLyLzsACJmh+CNt7rsiw8BWDg8WXJSbMStmazcjfKdxalOZJWMhMMygjFE7zViyZ7abDre1hBZgxbP31K91BsC3DQiYzH0THWT7gQDVZjW1Zp4WuwR7Z/fLPaAY3UiNdCfb0Fu9/T64phQTNSOSB6hjpHihZ8odqzZveaGoHfJCCAy+eeQyD5WchPAvDUVudWQNJt5BGA6HCeBFNPtEMl8g92z5YBRBxhK3FYx0iqfo9Ii9ELt6myZjkIJrgyl/4tdGAhswGLm8eSa3YUeSFCwQD610/U0Tg381xcBFure3s8VOo7O/LR7CpbJgTaiv0TNNKMARAOdt0HkqKw0pU8ISGhrXbs70TnbnIh3pBanzT3A1hafGbMRSTqaT2cbGH0dqU0O3BZEDMaAJVJMIwH/UDIuYjCmNKN/zPT/qYmLGKHYcXixU3Pvhx/CzIymqFof7/kthhpYHIHU/vaN31Zf6lzaPF+p9Bl9wTOCOwXKueikuHoFTz/WMMy48JgKO8SU5nzovwGp2gAUXh61fgAAAABJRU5ErkJggg=='
                        },
                      },
                      img2 : {
                        backgroundColor : {
                          image : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAAEhyb7BAAAAAXNSR0IArs4c6QAAAjZJREFUOBGFVL9rFFEQnnm7pAnngV0Qf2HuvNS2R1oLiWARbIOFl2AhFgb/BLERi+RygiJYiYVFsLANaVNnSSLJReQ6IYaAyO0b55vdt75bMC7cvu998+3MvJl5R6TPUf/mA6wMwOTfkHAPBA3X2w8N4PWt377Ew35LsEmJk7vk/Qybab311DO9UJypYdVBq4S5VbIDJYR0vDE3f7zWvg/M5p5lgA1iOgPli1leTRAi/NiihawaSeODEUeDuRnO84X4c2Av8vv6o/13jKji8w6FYJHSEb/3QtuO8rzIMTIGqIIusIU7XGstOeYpx9QVkkVNbKS25xBUOWGDKoinrnc87dgdXFne3QKPZ8JTQf19S5JsXuvtjtLhRmdBazeliT9RcydInNCqL0782qG4yCUWQFh2xGpulUSywUN99eJnC1Fxmrrd9s7LWeiJHbemyrBnp8VEHcyIURI+1OP+QqUVv0RbLq/sfbcS/Bjcap7mpzYQlTfnRleXs03zVpEKTCxn89U4xcYYq4MGT29d7O2cBLqKdjL+eQ/tCwaUDv3VgbP+o53KbWMoggYpN9MLn+CQbbiF7gRjvTkVPwkynD1QGuCzw2wEQtdn+qs6HPF1CA209sCHw4AFIhwj7M9bY60NKaY0fMDEHwP+3xpr4cOKXQ6vFdWRNMs/hH8dMdOhfuuJi46VI2COEB13XMbj23HnzssKHeM0/YJrBF3lKP7ILignN3D1Qw0x45QkI5b8K6Y01gP/AU+g7HhTtlHDAAAAAElFTkSuQmCC'
                        },
                      },
                      img3 : {
                        backgroundColor : {
                          image : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAAEhyb7BAAAAAXNSR0IArs4c6QAAAhBJREFUOBGFU01LHEEQrZqVUbORPYvHePBHyB5Xo+NCAkuuwUM8Sg4Rf0LIRXJMwBDwJAsKuvnQo/gjPBg8hTmL2cQIu+17/TUzK2rDTL+uel1d/apaBMO0llc5qwfbwGs00PPGArvIshlSDBdjUtO2DMy0Wlcrewf2B+AzODYSAy4MNiyMc2SSiIjtpmllr4gZjOE/cYGxlrg5/j+OGtb9aT6rxpNdZ1h4OS3m/0rcGEBibvTn9684qN0UGczBHg4LFKSkO0jlFGcNXY6Fq0Bq5rlwxy0uvZahptg5j50d2HN870mQkBOxVeFGsNPURWrnenxwQjtHNZKzFX8dP9SjvXzMPM9WoF0Kz1t8vIAfuuFv/Dmx4jKXCoE8WxGruVPSJesjjE6D2SA3b3PP0H4guetWaWd2mQrEhA7ex1a6wHdtlRbZEpal1/vtJOh0GnL51zaE3wCpNNcfvUOuLSk4DMl//jVjOwXH6IwA8nTyRLvdy+AqTrvqv7DlCx5XRsoX6p8j1VM2RaAwZZmq7zOgurKa5ei8U5ySp4AUZysuU/2WiO2NaNoEKlU42kcBOeS6gRgoCRssjnCNaHgAlLimjkC180g22o34MVDhotPJ983rT9AGLKsw33dF6KNfwHEV8y0Qy2/4xvV6oVK5h7JixczEEZ8RaTFQeY+rZPLMPf2gofZFklzS4S92aZlPfAtGuLum54pX6gAAAABJRU5ErkJggg=='
                        },
                      }
                    }
                  },
                  emphasis: {
                    show: false
                  }
                },
                itemStyle: {
                  normal: {
                    color:'#06DFF9',
                    shadowBlur: 10,
                    shadowColor: '#333',
                    emphasis:{
                      show:false
                    },
                  },
                  emphasis:{
                    show:false
                  },
                },
                symbolSize: 12,
                emphasis:{
                  show:false
                },
                data: cp
              },
            ];
          //渲染地图
          chart.setOption(option);
        }
      },
      init() {
        contractMap().then(res => {
          let data = res.data
          if (data.code === '000') {
            this.detail = data.content
            this.$nextTick(function () {
              this.initEcharts()
            })
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {

        })
      },
    },
    created() {
      this.init()
    },
    computed: {
      ...mapState({
        areaName: state => state.user.user.areaName,
        cityName: state => state.user.user.cityName,
      })
    },
  }
</script>

<style scoped lang="scss">
  .map-container {
    background: url("/img/bigdata/map-bg.png") center center no-repeat;
    background-size: cover;
  }
  .address{
    position: absolute;
    left: 38px;
    top: 88px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #B8D7FF;
    img{
      height: 18px;
      margin-right: 8px;
    }
  }
  .lenged{
    position: absolute;
    bottom: 52px;
    left: 38px;
    .item{
      display: flex;
      align-items: center;
      color: #B8D7FF;
      font-size: 14px;
      margin-top: 15px;
      img{
        margin-right: 8px;
      }
    }
  }
</style>
